import { render, staticRenderFns } from "./LifeSchoolItemDetail.vue?vue&type=template&id=1a08cd06"
import script from "./LifeSchoolItemDetail.vue?vue&type=script&lang=js"
export * from "./LifeSchoolItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports